<template>
  <div class="empty">
    <img src="../assets/image/customization/empty.png" />
    <p>暂无活动</p>
  </div>
</template>

<script>
export default {
  name: 'empty'
}
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 45px;
  margin-bottom: 45px;
  width: 100%;
  height: 85px;
  img {
    width: 72px;
    height: 63px;
  }
  p {
    margin-top: 10px;
    font-size: 14px;
    color: #c0c4cc;
    font-weight: 500;
  }
}
</style>
